import { ToastErrorIcon } from "../../../../../icons";

const LinkAddDialogError = ({ error }: { error: string }) => {
  return (
    <div className="flex items-center justify-center gap-1.5 pt-5">
      <ToastErrorIcon />
      <span className="text-[13px] text-body1 font-normal text-error-red transition-opacity duration-300">
        {error}
      </span>
    </div>
  );
};

export default LinkAddDialogError;
